import React from "react";

const MemberOrgs = () => (
  <div>
    <h2 className="member-tabs__title">Organizations</h2>
  </div>
);

export default MemberOrgs;
